module.exports = __webpack_public_path__ + "img/picto-acquisition.58086631.svg";